import React, { useContext } from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { useTheme } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';

import WarningIcon from '@material-ui/icons/Warning';

import { CustomDialogBodySizeEditable, ModalSizeEditableContext } from 'components/common/ModalSizeEditableContext';
import { ButtonClose } from 'components/common/buttons/ButtonClose';
import { ButtonRemove } from 'components/common/buttons/ButtonRemove';
import { useDesprovisionarReferenciaBancoInterAutomatico } from '../hooks';
import TabelaDadosNossoNumero from '../TabelaDadosNossoNumero';

const optionsMotivo = [
	{ abv: 'ACT', name: 'Cancelado por acertos' },
	{ abv: 'APC', name: 'Cancelado a pedido do cliente' },
	{ abv: 'PDC', name: 'Cancelado por ter sido pago direto ao cliente' },
	{ abv: 'SUB', name: 'Cancelado por substituição' },
];

export const ModalConfirmaDesprovisionamentoBancoInterAutomatico = ({ recebimentosNossoNumero, setLoading }) => {
	const { setModalValue } = useContext(ModalSizeEditableContext);
	const {
		palette: { syndikosRed },
	} = useTheme();
	const desprovisionar = useDesprovisionarReferenciaBancoInterAutomatico();
	const [senha, setSenha] = React.useState('');

	const [motivo, setMotivo] = React.useState(null);
	const [desprovisionando, setDesprovisionando] = React.useState(false);

	return (
		<CustomDialogBodySizeEditable
			title='Deseja realmente excluir o provisionamento das arrecadações?'
			text={
				<Box display='flex' alignItems='flex-start' gridGap='20px'>
					<Box>
						<WarningIcon style={{ color: syndikosRed.main }} fontSize='large' />
					</Box>
					<Box>
						<Typography
							style={{
								fontWeight: 'bold',
								color: syndikosRed.main,
							}}
						>
							Já existem unidades com o nosso número de cobrança gerado, ao confirmar a exclusão essa
							numeração será removida e a cobrança no banco será excluída!
						</Typography>
						<Typography
							style={{
								fontWeight: 'bold',
								color: syndikosRed.main,
							}}
						>
							Por segurança, solicitamos sua senha de login novamente para cancelar os boletos.
						</Typography>
						<TextField
							name='password'
							fullWidth
							type='password'
							label='Senha do usuário'
							value={senha}
							variant='outlined'
							onChange={(e) => setSenha(e.target.value)}
							size='small'
						/>

						<Typography
							style={{
								fontWeight: 'bold',
								color: syndikosRed.main,
							}}
						>
							Informe o motivo dos cancelamentos.
						</Typography>

						<Box>
							<Autocomplete
								fullWidth
								autoHighlight
								id=''
								value={motivo}
								onChange={(event, newValue) => {
									setMotivo(newValue);
								}}
								options={optionsMotivo}
								getOptionLabel={(option) => option.name}
								renderInput={(params) => (
									<TextField
										autoComplete='off'
										{...params}
										label='Motivo do Cancelamento'
										variant='outlined'
										id=''
									/>
								)}
							/>
						</Box>

						<TabelaDadosNossoNumero recebimentosNossoNumero={recebimentosNossoNumero} />
					</Box>
				</Box>
			}
			customActions={
				<>
					<ButtonClose
						onClick={() => {
							setModalValue({ open: false });
							setLoading?.(false);
						}}
						size='small'
						disabled={desprovisionando}
					>
						cancelar
					</ButtonClose>
					<ButtonRemove
						onClick={() => {
							setDesprovisionando(true);
							desprovisionar({
								senha,
								motivo,
								callbackSuccess: () => {
									setLoading?.(false);
									setModalValue({ open: false });
									setDesprovisionando(false);
								},
								callbackFail: () => {
									setDesprovisionando(false);
								},
							});
						}}
						size='small'
						disabled={!senha || !motivo || desprovisionando}
					/>
				</>
			}
		/>
	);
};

export default ModalConfirmaDesprovisionamentoBancoInterAutomatico;
